import { useEffect, useState } from "react"
import { doc, onSnapshot, Timestamp } from "firebase/firestore"
import { db } from "@/lib/firebase"
import type { Event } from "@/types/models"

export function useEventById(eventId: string | null | undefined) {
  const [event, setEvent] = useState<Event | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<unknown>(null)

  useEffect(() => {
    if (!eventId) {
      setEvent(null)
      setLoading(false)
      return
    }

    setLoading(true)
    
    const eventRef = doc(db, "events", eventId)
    
    const unsubscribe = onSnapshot(eventRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data()
        const eventData: Event = {
          id: snapshot.id,
          eventName: data.eventName as string,
          eventDescription: data.eventDescription as string,
          eventBannerUrl: data.eventBannerUrl as string,
          eventDates: (data.eventDates as any[])?.map((dateObj: any) => ({
            date: dateObj.date instanceof Timestamp ? dateObj.date.toDate() : new Date(dateObj.date),
            displayStartTime: dateObj.displayStartTime as string,
            displayEndTime: dateObj.displayEndTime as string
          })) || [],
          address: data.address as string,
          city: data.city as string,
          country: data.country as string,
          artistId: data.artistId as string | undefined,
          artistIds: data.artistIds as string[] || [],
          identifier: data.identifier as string,
          createdAt: data.createdAt?.toDate() || new Date(),
          isAvailable: data.isAvailable as boolean | undefined
        }
        setEvent(eventData)
      } else {
        setEvent(null)
      }
      setLoading(false)
    }, (err) => {
      console.error('Error fetching event by ID:', err)
      setError(err)
      setLoading(false)
    })

    return () => unsubscribe()
  }, [eventId])

  return { event, loading, error }
}
